// src/utils/localAxios.js
import axios from 'axios'
import sysConfig from '../utils/staticConfig.js'

export default axios.create({
  baseURL: `${sysConfig.serverUrl}${sysConfig.apiVersion}`,
  // ← no interceptor() call here, so no showError / SET_SNACKBAR ever fires
})
